import "primereact/resources/themes/lara-light-blue/theme.css"; // ou outro tema
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import Login from "./pages/login";
import Home from "./pages/home";
import Product from "./pages/product";
import ShoppingCart from "./pages/shoppingCart";
import Payment from "./pages/payment";
import PaymentConclude from "./pages/paymentConclude";
import Profile from "./pages/profile";
import Category from "./pages/category";
import Orders from "./pages/orders";
import Store from "./pages/store";
import Register from "./pages/register";
import SaleOrder from "./pages/saleOrder";
import HowToUse from "./pages/howToUser";
import ActiveRegister from "./pages/activeRegister";
import BhnIncentivos from "./pages/BhnIncentivos";
import SaleOrderConclude from "./pages/saleOrderConclude";
import ProductDetails from "./pages/details";
import ResetPassword from "./pages/resetpassword";
import Brands from "./pages/brands";
import Companies from "./pages/companies";
import TabLogin from "./pages/tabLogin";
import HowItWorks from "./pages/howItWorks";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <>
        <div className="app-process">
            <div>
                <div></div>
                Aguarde...
            </div>
        </div>

        <Router>
            <Routes>
                <Route
                    exact
                    path="/"
                    element={
                        <App>
                            <Home />
                        </App>
                    }
                />
                <Route
                    path="/category/:category"
                    element={
                        <App>
                            <Category />
                        </App>
                    }
                />
                <Route
                    path="/cart"
                    element={
                        <App>
                            <ShoppingCart />
                        </App>
                    }
                />
                <Route
                    path="/payment"
                    element={
                        <App>
                            <Payment />
                        </App>
                    }
                />
                <Route
                    path="/orders"
                    element={
                        <App>
                            <Orders />
                        </App>
                    }
                />
                <Route
                    path="/saleorder/:id"
                    element={
                        <App>
                            <SaleOrder />
                        </App>
                    }
                />
                <Route
                    path="/saleorder/conclude/:id"
                    element={
                        <App>
                            <SaleOrderConclude />
                        </App>
                    }
                />
                <Route
                    path="/payment/conclude/:id"
                    element={
                        <App>
                            <PaymentConclude />
                        </App>
                    }
                />
                <Route
                    path="/product/:id"
                    element={
                        <App>
                            <Product />
                        </App>
                    }
                />
                <Route
                    path="/store"
                    element={
                        <App>
                            <Store />
                        </App>
                    }
                />
                <Route
                    path="/profile"
                    element={
                        <App>
                            <Profile />
                        </App>
                    }
                />
                <Route
                    path="/howtouse"
                    element={
                        <App>
                            <HowToUse />
                        </App>
                    }
                />
                <Route
                    path="/brands"
                    element={
                        <App>
                            <Brands />
                        </App>
                    }
                />
                <Route
                    path="/companies"
                    element={
                        <App>
                            <Companies />
                        </App>
                    }
                />
                <Route path="/login" element={<App><TabLogin activeIndex={0} /></App>} />
                <Route path="/register" element={<App><TabLogin activeIndex={1} /></App>} />
                <Route path="/user/confirmemail/:id" element={<ActiveRegister />} />
                <Route path="/how-it-works" element={<App><HowItWorks /></App>} />
                <Route path="/details/:id" element={<ProductDetails />} />
                <Route
                    path="/BhnIncentivos"
                    element={
                        <App>
                            <BhnIncentivos />
                        </App>
                    }
                />
                <Route path="/user/resetpassword" element={<ResetPassword />} />
            </Routes>
        </Router>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
